/**
 * CTR Reasons FAQs – Smooth accordion
 * Supports:
 *  - Smooth height transition on open / close
 *  - "Allow multiple open" via data-allow-multiple
 *  - "Open by default" via data-open-default on individual items
 */
(function () {
  function initFaqs(container) {
    if (!container) return;

    const allowMultiple = container.dataset.allowMultiple === 'true';
    const items = container.querySelectorAll('.ctr-reasons-faqs__item');

    items.forEach((item) => {
      const header = item.querySelector('.ctr-reasons-faqs__item-header');
      const body = item.querySelector('.ctr-reasons-faqs__item-body');
      if (!header || !body) return;

      // Open-by-default items
      if (item.dataset.openDefault === 'true') {
        openItem(item, body, false);
      }

      header.addEventListener('click', () => {
        const isOpen = item.classList.contains('is-open');

        if (!allowMultiple && !isOpen) {
          // Close other items first
          items.forEach((otherItem) => {
            if (otherItem !== item && otherItem.classList.contains('is-open')) {
              const otherBody = otherItem.querySelector('.ctr-reasons-faqs__item-body');
              closeItem(otherItem, otherBody, true);
            }
          });
        }

        if (isOpen) {
          closeItem(item, body, true);
        } else {
          openItem(item, body, true);
        }
      });
    });
  }

  function openItem(item, body, animate) {
    item.classList.add('is-open');
    item.querySelector('.ctr-reasons-faqs__item-header')
      .setAttribute('aria-expanded', 'true');

    if (animate) {
      const inner = body.querySelector('.ctr-reasons-faqs__item-body-inner');
      const targetHeight = inner.scrollHeight;
      body.style.height = '0px';

      // Force reflow
      body.offsetHeight; // eslint-disable-line no-unused-expressions

      body.style.height = targetHeight + 'px';

      const onEnd = () => {
        body.style.height = 'auto';
        body.removeEventListener('transitionend', onEnd);
      };
      body.addEventListener('transitionend', onEnd);
    } else {
      body.style.height = 'auto';
    }
  }

  function closeItem(item, body, animate) {
    item.querySelector('.ctr-reasons-faqs__item-header')
      .setAttribute('aria-expanded', 'false');

    if (animate) {
      // Set explicit height first so transition works
      body.style.height = body.scrollHeight + 'px';

      // Force reflow
      body.offsetHeight; // eslint-disable-line no-unused-expressions

      body.style.height = '0px';

      const onEnd = () => {
        item.classList.remove('is-open');
        body.removeEventListener('transitionend', onEnd);
      };
      body.addEventListener('transitionend', onEnd);
    } else {
      body.style.height = '0px';
      item.classList.remove('is-open');
    }
  }

  // Init on DOM ready
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.ctr-reasons-faqs__items').forEach(initFaqs);
  });

  // Shopify Theme Editor support
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (e) => {
      const container = e.target.querySelector('.ctr-reasons-faqs__items');
      if (container) initFaqs(container);
    });
  }
})();
